import { Injectable } from '@angular/core';

/**
 * Whether the runtime's copy of the Accounts table has been left behind by a workflow write.
 *
 * The runtime keeps the account rows — and the account the session is acting as — in the store. A
 * workflow node that writes to the Accounts table invalidates both, so the next read refetches the
 * rows instead of trusting the store. Set by whoever writes, cleared by whoever refetches.
 *
 * It is deliberately not NgRx state: nothing renders from it, and the write happens mid-execution
 * from services that are not reducers.
 */
@Injectable({ providedIn: 'root' })
export class AccountsTableStaleness {
  private stale = false;

  get isStale(): boolean {
    return this.stale;
  }

  markStale(isStale: boolean): void {
    this.stale = isStale;
  }
}
